<script>
  import { Utils } from "../../utils";
  import { format } from "date-fns";
  import { user } from "../../firebase";
  export let attachment;
  export let preview;

  let img;
  if (attachment.from == "clickup") {
    img = attachment.token;
  } else {
    img = Utils.file.tokenToLink(
      `stores/${$user.auth.claims.store}/${attachment.name}`,
      attachment.token
    );
  }

  let date = format(new Date(parseInt(attachment?.date)), "MMM d, uuu");
  let imagetype = [
    "jpg",
    "JPG",
    "png",
    "PNG",
    "jpeg",
    "JPEG",
    "svg",
    "SVG",
    "gif",
    "GIF",
  ];
</script>

<div class="attachmentWrapper">
  <div class="Content">
    <div class="leftImage">
      {#if imagetype.includes(attachment.type)}
        <div class="attach">
          <img
            on:click={() => {
              preview = img;
            }}
            class="attach-img"
            src={img}
            alt=""
          />
        </div>
      {:else if attachment.type == "zip"}
        <div class="attach">
          <img class="attach-img" src="../images/tasks/zip.svg" alt="" />
        </div>
      {:else}
        <div class="attach">
          <img class="attach-img" src="../images/tasks/file.svg" alt="" />
        </div>
      {/if}
    </div>
    <div class="mainContent">
      <h6>{attachment.name}</h6>
      <div class="download-see">
        <div
          on:click={() => {
            preview = img;
          }}
          class="Elem elem1"
        >
          <img
            style="margin-right:0.2rem"
            src="../images/Fill 1159.svg"
            alt=""
          />
          <h3>see</h3>
        </div>
      </div>
      <div class="createdAt_Attachment">
        <i class="bx bxs-calendar-alt" />
        <h6>{date}</h6>
      </div>
    </div>
  </div>
</div>

<style>
  ::-webkit-scrollbar {
    width: 5px;
    border-radius: 20px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--primaryColor);
    border-radius: 10px;
  }

  * {
    padding: 0;
    margin: 0;
  }

  .attach {
    height: 100%;
  }

  .attachmentWrapper {
    /* background: green; */
    padding: 1rem 1rem 1rem 0;
    border: solid 1px #d8e0f0;
    border-radius: 14px;
    margin-bottom: 0.5rem;
    box-shadow: 0px 1px 2px 0px #b8c8e039;
  }

  .leftImage {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 35%;
    cursor: pointer;
    /* background: red; */
  }

  .leftImage img {
    height: 100%;
    width: 90%;
  }

  .mainContent {
    width: 50%;
  }

  .Content {
    display: flex;
    flex-direction: row;
    height: 6rem;
  }

  .rightarray {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 10%;
  }

  .download-see {
    display: flex;
    flex-direction: row;
    margin-top: 0.5rem;
    cursor: pointer;
    /* background-color: #00d097; */
  }

  .Elem {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 0.2rem;
  }

  .elem1 {
    width: 20%;
    margin-right: 1rem;
  }
  .elem2 {
    width: 35%;
  }

  .Elem h3 {
    color: #7d8592;
    font-size: 0.8em;
    font-weight: 500;
  }

  .bx-cloud-download {
    color: #2c8f73;
  }

  .mainContent h6 {
    font-size: 1.2em;
    font-weight: 500;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .createdAt_Attachment {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 1rem;
  }

  .createdAt_Attachment i {
    color: #7d8592;
    margin-right: 0.5rem;
  }
  .createdAt_Attachment h6 {
    font-size: 0.8rem;
    color: #7d8592;
  }
</style>
